export default "__VITE_ASSET__d0ff7147__"